import mixpanel from 'mixpanel-browser'

function getUtmParameters() {
  const urlParams = new URLSearchParams(window.location.search)
  const utmParams = {}

  const redirected = urlParams.get('utm_source') ? 'true' : 'false'
  utmParams['redirected'] = redirected

  ;['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(param => {
    const value = urlParams.get(param)
    utmParams[param] = value ? value : 'NA'
  })

  const clItem = urlParams.get('cl_item')
  const clItems = urlParams.get('cl_items')

  if (clItem || clItems) {
    const combined = [clItems, clItem]
      .filter(Boolean)
      .map(v => v.replace(/\|/g, ','))
      .join(',')
    utmParams['cl_items'] = combined
  } else {
    utmParams['cl_items'] = 'NA'
  }

  return utmParams
}

export function initMixpanel(env) {
  const token = process.env.VUE_APP_MIXPANEL_TOKEN
  if (!token) return

  // CW-2239: Pass the GPC decision into init() so the SDK honours it before
  // autocapture starts. _gdpr_init() applies opt_out_tracking_by_default and
  // opt_out_persistence_by_default before Autocapture.initPageviewTracking()
  // fires, preventing any $mp_web_page_view event or distinct_id write for
  // GPC-signalling browsers on their very first visit.
  const gpc = !!navigator.globalPrivacyControl
  mixpanel.init(token, {
    debug: process.env.NODE_ENV !== 'production',
    autocapture: true,
    opt_out_tracking_by_default: gpc,
    opt_out_persistence_by_default: gpc
  })

  if (gpc) return

  // CW-2239: Only call opt_in_tracking() when there is a stale opt-out stored
  // in localStorage (mp_optout=1) — e.g. the user previously had GPC on and
  // has now turned it off. Calling it unconditionally fires an $opt_in event
  // on every page load for every non-GPC visitor, adding junk to funnels and
  // consuming event volume across 100% of traffic.
  if (mixpanel.has_opted_out_tracking()) {
    mixpanel.opt_in_tracking()
  }

  mixpanel.register({ environment: env, ...getUtmParameters() })

  window.addEventListener('beforeunload', () => {
    const now = new Date()
    mixpanel.track('Exit_Page', {
      page: window.location.pathname,
      dateVisited: now.toLocaleDateString(),
      timestamp: now.toISOString()
    })
  })

  window.addEventListener('scroll', () => {
    const scrollDepth = Math.round((window.scrollY / document.body.scrollHeight) * 100)
    if (scrollDepth >= 50) {
      const now = new Date()
      mixpanel.track('Scroll_Depth_Reached', {
        depth: scrollDepth,
        dateVisited: now.toLocaleDateString(),
        timestamp: now.toISOString()
      })
    }
  })
}

export function trackMixpanelRoute(to, from) {
  // No-op if opted out (GPC) or not initialised
  if (mixpanel.has_opted_out_tracking()) return

  const now = new Date()
  const dateVisited = now.toLocaleDateString()
  const timestamp = now.toISOString()

  mixpanel.track('Page_Viewed', {
    page: to.fullPath,
    from: from.fullPath,
    dateVisited,
    timestamp
  })

  mixpanel.track('Navigation_Sequence', {
    from: from.fullPath,
    to: to.fullPath,
    dateVisited,
    timestamp
  })

  mixpanel.track('Date_Viewed', {
    page: to.fullPath,
    dateVisited,
    timestamp
  })
}

export { mixpanel }
